import React from 'react'
import PropTypes from 'prop-types'

import BlankStateSection from 'components/BlankStateSection'
import Button from 'components/Button'
import LoadingBubbles from 'components/LoadingBubbles'
import Modal from 'modals/Modal'

import BuildingDocumentImage from './assets/building-document.svg'

import styles from './styles.scss'

const renderContent = () => (
  <BlankStateSection
    imageAlt="Building Document"
    imageUrl={BuildingDocumentImage}
    style={{ marginLeft: 25 }}
  >
    <p>
        Have a quick break while we build your document. We are combining your
        form data and other assets in to one document that can be sent or signed
        by your client.
    </p>

    <p>
        Please wait while we build your file in the background. It should only
        take a few moments. If you experience any issues please contact support.
    </p>

    <p>
      <Button
        color="lightGrey"
        disabled
        icon={<LoadingBubbles color="#ffffff" />}
        size="medium"
        text="Please Wait..."
      />
    </p>
  </BlankStateSection>
)

const BuildingExternalDocumentModal = (props) => {
  const { building, callbacks: { closeModal }, showModal } = props

  return (
    <Modal
      showModal={showModal}
      title={building ? 'Building Document' : 'Document Ready'}
      closeModalCallback={closeModal}
    >
      <div className={styles.root}>
        {renderContent(props)}
      </div>
    </Modal>
  )
}

BuildingExternalDocumentModal.propTypes = {
  building: PropTypes.bool,
  callbacks: PropTypes.shape({
    closeModal: PropTypes.func.isRequired,
  }).isRequired,
  showModal: PropTypes.bool,
}

export default BuildingExternalDocumentModal
